import NavBar from '@/components/NavBar/NavBar.vue';
import CustomTable from '@/components/CustomTable/CustomTable.vue';
import CustomTabs from '@/components/CustomTab/CustomTab.vue';
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { LOGOUT } from "@/utils/logout.js";
import draggable from 'vuedraggable';
import { useToast } from "@/components/Toast/useToast";
import Swal from 'sweetalert2';

export default {
    name: 'ManageForm',
    mixins: [LOGOUT],
    pageTitle: 'Manage Form',
    setup() {
        const { showSuccess, showError, showWarning } = useToast();
        
        return {
            showSuccess,
            showError,
            showWarning
        };
    },
    components: {
        NavBar,
        draggable,
        CustomTable,
        CustomTabs
    },

    data: () => ({
        question: '',
        question_type: '',
        questions: [],
        selected_questions: [],
        assigned_question_ids: [],
        question_id: '',
        activeTab: 'form',
        isAssignedQuestionsOpen: false,
        loading: false,
        selectedQuestion: {
          id: null,
          question: '',
          question_type: '',
          weight: 0,
          rules: []
        },
        showConfigModal: false,
        totalWeight: 0,
        showWeightModal: false,
        weightQuestion: {},
        showThresholdModal: false,
        thresholds: {
            high: {
                operator: '>=',
                value: 75
            },
            medium: {
                lowerOperator: '>=',
                lowerValue: 50,
                upperOperator: '<',
                upperValue: 75
            },
            low: {
                operator: '<',
                value: 50
            }
        },
        editThreshold: {},
        currentLevel: null,
        modalTitle: '',
        validationError: null,
        modal: null,
        ordered_questions: [],
        last_saved_ordered_ids: [],
        service_name: '',
        questionsColumns: [
          { label: 'Question', key: 'question' },
          { label: 'Question Type', key: 'question_type' },
          { label: 'Assign Question', key: 'assign_question'}
        ],
        rulesColumns: [
          { label: 'Question', key: 'question' },
          { label: 'Question Type', key: 'question_type' },
          { label: 'Question Score (%)', key: 'score' },
          { label: 'Rules', key: 'rules' }
        ],
        thresholdsColumns: [
          { label: 'Severity Level', key: 'level' },
          { label: 'Threshold', key: 'threshold' },
        ],
        thresholdsTableKey: Date.now(),
    }),
    methods: {
      // Wrapper method to ensure SweetAlert confirmation is accessible in AJAX callbacks
      async handleConfirmation(message) {
        const result = await Swal.fire({
          title: 'Confirm Action',
          text: message,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, Continue',
          cancelButtonText: 'Cancel',
          reverseButtons: true
        });
        return result.isConfirmed;
      },
      
      get_questions(page = 1, search = "") {
      const TOKEN = localStorage.getItem("token");
      let url = `${API_BASE_URL}/verify_api/question_management_api/get_questions_api/?page=${page}`;
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      return new Promise((resolve, reject) => {
        $.ajax({
          url,
          method: "GET",
          contentType: "application/json",
          headers: {
            Authorization: `Token ${TOKEN}`,
          },
          success: (response) => {
            resolve({
              count: response.count,
              results: response.results,
            });
          },
          error: (xhr, status, error) => {
            reject(error);
          },
        });
      });
    },

    get_active_questions(page = 1, search = "") {
      const TOKEN = localStorage.getItem("token");
      let url = `${API_BASE_URL}/verify_api/question_management_api/get_active_questions_api/?page=${page}`;
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      return new Promise((resolve, reject) => {
        $.ajax({
          url,
          method: "GET",
          contentType: "application/json",
          headers: {
            Authorization: `Token ${TOKEN}`,
          },
          success: (response) => {
            resolve({
              count: response.count,
              results: response.results,
            });
          },
          error: (xhr, status, error) => {
            reject(error);
          },
        });
      });
    },

      fetch_custom_service_question(){
        const TOKEN = localStorage.getItem('token');
        const self = this; // Capture Vue component reference
      
        const GET_QUESTIONS_API = `${API_BASE_URL}/verify_api/form_management_api/get_questions_for_service_api/${this.service_id}`;
        
        $.ajax({
          url: GET_QUESTIONS_API,
          method: 'GET',
          contentType: 'application/json',
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          beforeSend: () => {
            // Remove loading modal for better UX
          },
          success: (response) => {
            self.service_name = response.service_name || 'Custom Service';
            self.questions = response.questions;

            self.assigned_question_ids = self.questions
            .filter(q => q.is_active)
            .map(q => q.id);

            self.loading = false;
            
            // Calculate weight percentages after updating weights
            self.calculateWeightPercentages();
          },
          error: () => {
            console.error("Error fetching questions for service");
          }
        });
      },

      assign_question(question_id, is_checked, force_proceed = false) {
        const TOKEN = localStorage.getItem('token');
        const UPDATE_QUESTION_URL = `${API_BASE_URL}/verify_api/form_management_api/assign_question_to_service_api/`;
        const self = this; // Capture Vue component reference

        const payload = {
          question_id: question_id,
          service_id: this.service_id,
          is_checked: is_checked,
          force_proceed: force_proceed 
        };

        const makeApiCall = (requestPayload) => {
          $.ajax({
            url: UPDATE_QUESTION_URL,
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(requestPayload),
            headers: {
              Authorization: `Token ${TOKEN}`
            },
            beforeSend: () => {
            },
            success: async (response) => {
              if (response.status === 'warning' && response.requires_confirmation) {
                
                const confirmed = await self.handleConfirmation(response.message);
                if (confirmed) {
                    requestPayload.force_proceed = true;
                    makeApiCall(requestPayload);
                } else {
                    const checkbox = document.getElementById(`question-checkbox-${question_id}`);
                    if (checkbox) {
                        checkbox.checked = !is_checked;
                    }
                }

              } else if (response.status === 'success') {
                self.showSuccess(response.message);

                if (response.assigned_question_ids) {
                  self.assigned_question_ids = response.assigned_question_ids;
                }

                self.fetch_custom_service_question();

              } else {
                self.showError(response.message || 'An unknown error occurred.');
              }
            },
            error: (xhr) => {
              let errorMessage = 'An error occurred while processing your request.';
              if (xhr.responseJSON && xhr.responseJSON.message) {
                errorMessage = xhr.responseJSON.message;
              }
              self.showError(errorMessage);
              
              const checkbox = document.getElementById(`question-checkbox-${question_id}`);
              if (checkbox) {
                  checkbox.checked = !is_checked;
              }
            }
          });
        };

        makeApiCall(payload);
      },

      save_ordered_questions() {
        const TOKEN = localStorage.getItem('token');
        const SAVE_ORDER_API = `${API_BASE_URL}/verify_api/form_management_api/save_ordered_questions_api/`;
        const self = this; // Capture Vue component reference

        // Prepare the ordered list of question IDs
        const ordered_ids = this.ordered_questions.map(q => q.id);

        const FORM_DATA = {
          service_id: this.service_id,
          ordered_question_ids: ordered_ids,
          set_numbering: this.set_numbering
        };

        $.ajax({
          url: SAVE_ORDER_API,
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(FORM_DATA),
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          beforeSend: () => {
            // Remove loading modal for better UX
          },
          success: () => {
            self.last_saved_ordered_ids = [...ordered_ids];
            self.showSuccess('Question order saved successfully');
          },
          error: () => {
            self.showError('Failed to save question order');
          }
        });
      },
      
      rulesTableData() {
        return Promise.resolve({
          count: this.ordered_questions.length,
          results: this.ordered_questions,
          per_page: this.ordered_questions.length // disables pagination
        });
      },

      thresholdsTableData() {
        return Promise.resolve({
          count: this.thresholdsTableRows.length,
          results: this.thresholdsTableRows,
          per_page: this.thresholdsTableRows.length
        });
      },
      hasAssignedQuestions() {
        return this.ordered_questions.some(question => this.assigned_question_ids.includes(question.id));
      },

      updateOrderedQuestions() {
        // Only keep assigned and active questions, preserving order
        const assigned = this.questions.filter(q => q.is_active && this.assigned_question_ids.includes(q.id));

        // Remove unassigned from ordered_questions, keep order
        let newOrdered = this.ordered_questions.filter(q =>
          assigned.some(aq => aq.id === q.id)
        );

        // Add any newly assigned questions to the end
        assigned.forEach(q => {
          if(!newOrdered.some(oq => oq.id === q.id)) {
            newOrdered.push(q);
          }
        });

        // Force Vue reactivity by assigning a new array reference
        this.ordered_questions = newOrdered;
      },
      
      // Open the configuration modal for a specific question
      configQuestion(questionId) {
        // Find the question by ID
        const question = this.ordered_questions.find(q => q.id === questionId);
        
        if (question) {
          // Initialize rules array if it doesn't exist
          if (!question.rules) {
            question.rules = [];
          }
          
          // Create a deep copy of the question to work with
          this.selectedQuestion = JSON.parse(JSON.stringify(question));
          
          // Show modal using Vue's reactivity
          this.showConfigModal = true;
        }

        this.calculateWeightPercentages();
      },
      
      // Close the configuration modal
      closeConfigModal() {
        this.showConfigModal = false;
      },
      
      // Remove a rule
      removeRule(index) {
        this.selectedQuestion.rules.splice(index, 1);
      },

      isOptionSelected(option, rule) {
        if (!rule.value) return false;
        // Handle if rule.value is an object with option property
        if (typeof rule.value === 'object' && rule.value !== null) {
          if (rule.value.option) {
            return option.option === rule.value.option;
          }
          if (rule.value.id && option.id) {
            return option.id === rule.value.id;
          }
        }
        
        // Handle if rule.value is a string - direct comparison with option.option
        if (typeof rule.value === 'string') {
          return option.option === rule.value;
        }
        
        // Handle if options are stored as numbers
        if (typeof rule.value === 'number') {
          return option.id === rule.value || option.option === String(rule.value);
        }
        
        return false;
      },

      // Modified getAvailableOptions to ensure options are properly formatted
      getAvailableOptions() {
        if (!this.selectedQuestion.options || !Array.isArray(this.selectedQuestion.options)) {
          return [];
        }
        
        // Ensure all options have the expected format (id and option properties)
        return this.selectedQuestion.options.map(opt => {
          if (typeof opt === 'string') {
            return { id: opt, option: opt };
          } else if (typeof opt === 'object' && opt !== null) {
            return {
              id: opt.id || opt.value || opt.option,
              option: opt.option || opt.label || opt.text || String(opt.id)
            };
          }
          return opt;
        });
      },

      isOptionDisabled(option, currentIndex, isMulti = false) {
        // If it's a multi-select, we don't need to disable any options
        if (isMulti) return false;
        
        // For single select, check if the option is already selected in another rule
        const isUsed = this.selectedQuestion.rules.some((rule, idx) => {
          if (idx === currentIndex) return false; // Skip current rule
          
          // For single selection rules
          if (rule.value && rule.value.id === option.id) return true;
          
          // For multi-selection rules
          if (rule.multiValues && rule.multiValues.some(val => val.id === option.id)) return true;
          
          return false;
        });
        
        return isUsed;
      },

      addNewRule() {
        if (this.isMaxRulesReached()) {
          alert('Maximum number of rules reached for this question type.');
          return;
        }
      
        const newIndex = this.selectedQuestion.rules.length;
        const availableOptions = this.getAvailableOptions(newIndex);
        const defaultOption = availableOptions.length > 0 ? availableOptions[0] : null;
      
        let newRule = {
          severity: 'medium',
          operator: '==', // Default operator
          message: '',
          score: 0,
          value: null
        };
      
        switch (this.selectedQuestion.question_type) {
          case 'Number':
            newRule.operator = '==';
            newRule.value = 0;
            break;
      
          case 'Date':
            newRule.operator = '==';
            newRule.dateType = 'calendar';
            newRule.value = '';
            break;
      
          case 'Selection':
          case 'Choice':
          case 'Checkbox':
          case 'Multi Selection':
            newRule.value = defaultOption;
            break;
      
          case 'Boolean':
            newRule.operator = 'is_true';
            newRule.value = 'true';
            break;
      
          case 'File':
            newRule.operator = 'contains';
            newRule.fileProperty = 'extension';
            newRule.value = 'pdf';
            break;
      
          default: // Text and others
            newRule.operator = 'contains';
            newRule.value = '';
        }
      
        this.selectedQuestion.rules.push(newRule);
      },

      clampScore(rule) {  // Accept rule as a parameter
        // Check if selectedQuestion exists
        if (!this.selectedQuestion?.weight) {
          console.error("selectedQuestion.weight is undefined");
          return;
        }
    
        // Handle NaN/empty cases
        if (isNaN(rule.score)) {
          rule.score = 0;
        }
    
        // Clamp the value between 0 and selectedQuestion.weight
        rule.score = Math.max(
          0,
          Math.min(rule.score, this.selectedQuestion.weight)
        );
      },

      validateThresholdsValidation(event, modelName) {
        const target = event.target;
        let value = parseFloat(target.value);
      
        const min = parseFloat(target.min) || 0;
        const max = parseFloat(target.max) || 100;
      
        // Handle NaN cases (e.g., empty input)
        if (isNaN(value)) {
          value = min;
        } else {
          // Clamp the value between min and max
          value = Math.min(Math.max(value, min), max);
        }
      
        // Update the model
        this[modelName].value = value;
      },

      // Save the rules back to the question
      saveRules() {
        const TOKEN = localStorage.getItem('token');
        const SAVE_RULES_API = `${API_BASE_URL}/verify_api/form_management_api/save_question_rules_api/`;
        
        // Map rules to only include required fields
        const simplifiedRules = this.selectedQuestion.rules.map(rule => ({
          operator: rule.operator,
          score: rule.score,
          value: rule.value,
          severity_level: rule.severity
        }));

        const FORM_DATA = {
          question_id: this.selectedQuestion.id,
          service_id: this.service_id,
          rules: simplifiedRules
        };
        
        $.ajax({
          url: SAVE_RULES_API,
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(FORM_DATA),
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          beforeSend: () => {
            // Remove loading modal for better UX
          },
          success: () => {
            
            // Update local question data
            const questionIndex = this.ordered_questions.findIndex(q => q.id === this.selectedQuestion.id);
            if (questionIndex !== -1) {
              this.ordered_questions[questionIndex].rules = [...simplifiedRules];
            }
            
            this.calculateWeightPercentages();
            this.closeConfigModal();
            
            this.showSuccess('Rules saved successfully');
          },
          error: () => {
            this.showError('Failed to save rules');
          }
        });
      },

    // Updated getRules function with improved date handling
    getRules() {
      const TOKEN = localStorage.getItem('token');
      const GET_RULES_API = `${API_BASE_URL}/verify_api/form_management_api/get_question_rules_api/${this.service_id}/${this.question_id}`;

      $.ajax({
        url: GET_RULES_API,
        method: 'GET',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        beforeSend: () => {
          // Remove loading modal for better UX
        },
        success: (response) => {
          
          if (response.status === 'success' && response.data && response.data.rules) {
            // Transform API rules to match your frontend format
            const formattedRules = response.data.rules.map(rule => {
              // Base rule object that applies to all types
              const formattedRule = {
                severity: rule.severity_level ? rule.severity_level.toLowerCase() : 'medium',
                operator: rule.operator,
                score: rule.score
              };
              
              // Handle specific question types differently
              if (this.selectedQuestion.question_type === 'Selection' || 
                  this.selectedQuestion.question_type === 'Multi Selection' || 
                  this.selectedQuestion.question_type === 'Checkbox') {
                
                // Find the matching option object from available options
                const matchingOption = this.getAvailableOptions().find(opt => {
                  // Try different ways of matching based on what properties might be available
                  return (opt.id && String(opt.id) === String(rule.value)) || 
                        (opt.option && opt.option === rule.value) ||
                        (typeof rule.value === 'object' && rule.value && rule.value.id && 
                        opt.id && String(opt.id) === String(rule.value.id));
                });
                
                // If found, use the full option object, otherwise create one from the value
                if (matchingOption) {
                  formattedRule.value = matchingOption;
                } else {
                  formattedRule.value = {
                    id: typeof rule.value === 'object' ? rule.value.id : rule.value,
                    option: typeof rule.value === 'object' ? rule.value.option : rule.value
                  };
                }
              } else if (this.selectedQuestion.question_type === 'Date') {
                // Improved date handling
                
                // First, detect what type of date value we have
                if (rule.operator === 'Today') {
                  // Today/Current date case
                  formattedRule.dateType = 'current';
                  formattedRule.value = '';
                } else if (
                  // Check if it's a number of days (either as a number or string number)
                  (typeof rule.value === 'number') || 
                  (typeof rule.value === 'string' && !isNaN(rule.value) && rule.value.trim() !== '' && !rule.value.includes('-'))
                ) {
                  // Days number case
                  formattedRule.dateType = 'number';
                  formattedRule.daysValue = parseInt(rule.value);
                  formattedRule.value = ''; // Clear the value field as we're using daysValue
                } else if (rule.value && (
                  // Check for date strings in common formats (YYYY-MM-DD, MM/DD/YYYY, etc.)
                  (typeof rule.value === 'string' && 
                  (rule.value.includes('-') || rule.value.includes('/') || rule.value.includes('.')))
                )) {
                  // Calendar date case - ensure valid date format for input type="date"
                  formattedRule.dateType = 'calendar';
                  
                  // Try to parse and format the date to YYYY-MM-DD for the date input
                  try {
                    const dateObj = new Date(rule.value);
                    if (!isNaN(dateObj.getTime())) {
                      // Valid date, format as YYYY-MM-DD
                      const year = dateObj.getFullYear();
                      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                      const day = String(dateObj.getDate()).padStart(2, '0');
                      formattedRule.value = `${year}-${month}-${day}`;
                    } else {
                      // Couldn't parse, use as is
                      formattedRule.value = rule.value;
                    }
                  } catch (e) {
                    // If parsing fails, use as is
                    formattedRule.value = rule.value;
                  }
                } else {
                  // Default to calendar with empty value if we can't determine
                  formattedRule.dateType = 'calendar';
                  formattedRule.value = '';
                }
              } else if (this.selectedQuestion.question_type === 'File') {
                // For File types, set fileProperty based on the value or operator
                formattedRule.value = rule.value;
                formattedRule.fileProperty = rule.operator.includes('extension') || 
                                            (typeof rule.value === 'string' && rule.value.includes('.')) 
                                            ? 'extension' : 'size';
              } else if (this.selectedQuestion.question_type === 'Boolean') {
                // For Boolean types, ensure the value is a string 'true' or 'false'
                formattedRule.value = String(rule.value).toLowerCase();
              } else if (this.selectedQuestion.question_type === 'Number') {
                // For Number types, ensure the value is a number
                formattedRule.value = typeof rule.value === 'string' ? parseFloat(rule.value) : rule.value;
              } else {
                // For other types, use the value as is
                formattedRule.value = rule.value;
              }
              
              return formattedRule;
            });
            
            // Update selected question with fetched rules
            this.selectedQuestion.rules = formattedRules;
            
            // Update local question data
            const questionIndex = this.ordered_questions.findIndex(q => q.id === this.selectedQuestion.id);
            if (questionIndex !== -1) {
              this.ordered_questions[questionIndex].rules = formattedRules;
            }
            
            this.calculateWeightPercentages();
          } else {
            // If no rules found, initialize with empty array
            this.selectedQuestion.rules = [];
            
            const questionIndex = this.ordered_questions.findIndex(q => q.id === this.selectedQuestion.id);
            if (questionIndex !== -1) {
              this.ordered_questions[questionIndex].rules = [];
            }
          }
        },
        error: (error) => {
          console.error("Error fetching rules:", error);
          this.showError('Failed to load rules');
          
          // Initialize with empty rules on error
          this.selectedQuestion.rules = [];
        }
      });
    },

      // Helper function to find option by name
      getOptionIdByName(optionName) {
        if (!this.selectedQuestion.options || !Array.isArray(this.selectedQuestion.options)) {
          return null;
        }
        
        const foundOption = this.selectedQuestion.options.find(opt => {
          if (typeof opt === 'string') {
            return opt === optionName;
          } else if (typeof opt === 'object' && opt !== null) {
            return opt.option === optionName || opt.label === optionName || opt.text === optionName;
          }
          return false;
        });
        
        return foundOption ? (typeof foundOption === 'object' ? foundOption.id : foundOption) : null;
      },

      openConfigModal(question) {
        this.selectedQuestion = JSON.parse(JSON.stringify(question)); // Deep clone the question
        this.question_id = question.id;
        
        // Initialize rules as empty array before fetching
        this.selectedQuestion.rules = [];
        
        // Fetch rules for this question
        this.getRules();
        
        this.showConfigModal = true;
      },

      // Save thresholds
      saveThreshold() {
        // Validate basic input constraints first
        if (this.currentLevel === 'high' || this.currentLevel === 'low') {
          if (this.editThreshold.value < 0 || this.editThreshold.value > 100) {
            this.validationError = "Threshold value must be between 0 and 100";
            return;
          }
        } else if (this.currentLevel === 'medium') {
          if (this.editThreshold.lowerValue < 0 || this.editThreshold.lowerValue > 100 ||
            this.editThreshold.upperValue < 0 || this.editThreshold.upperValue > 100) {
            this.validationError = "Threshold values must be between 0 and 100";
            return;
          }
          
          if (this.editThreshold.upperValue <= this.editThreshold.lowerValue) {
            this.validationError = `Medium's upper threshold (${this.editThreshold.upperValue}%) must be greater than its lower threshold (${this.editThreshold.lowerValue}%)`;
            return;
          }
        }
        
        // Auto-adjust other thresholds based on the current change
        if (this.currentLevel === 'high') {
          // If high threshold is set, medium upper threshold should match it exactly
          this.thresholds.medium.upperValue = this.editThreshold.value;
          this.thresholds.high = JSON.parse(JSON.stringify(this.editThreshold));
        } 
        else if (this.currentLevel === 'medium') {
          // Update medium threshold
          this.thresholds.medium = JSON.parse(JSON.stringify(this.editThreshold));
          
          // Auto-adjust high threshold to match medium's upper value
          this.thresholds.high.value = this.editThreshold.upperValue;
          
          // Auto-adjust low threshold to match medium's lower value
          this.thresholds.low.value = this.editThreshold.lowerValue;
        }
        else if (this.currentLevel === 'low') {
          // If low threshold is set, medium lower threshold should match it exactly
          this.thresholds.medium.lowerValue = this.editThreshold.value;
          this.thresholds.low = JSON.parse(JSON.stringify(this.editThreshold));
        }
        
        // Send updated thresholds to backend
        const TOKEN = localStorage.getItem('token');
        const SAVE_THRESHOLDS_API = `${API_BASE_URL}/verify_api/form_management_api/save_service_thresholds_api/`;
        
        // Fix: Structure the thresholds object correctly to match the backend expectations
        const FORM_DATA = {
          service_id: this.service_id,
          thresholds: {
            high: {
              value: this.thresholds.high.value,
              operator: this.thresholds.high.operator
            },
            medium: {
              lowerValue: this.thresholds.medium.lowerValue,
              lowerOperator: this.thresholds.medium.lowerOperator,
              upperValue: this.thresholds.medium.upperValue,
              upperOperator: this.thresholds.medium.upperOperator
            },
            low: {
              value: this.thresholds.low.value,
              operator: this.thresholds.low.operator
            }
          }
        };
        
        $.ajax({
          url: SAVE_THRESHOLDS_API,
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(FORM_DATA),
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          beforeSend: () => {
            // Remove loading modal for better UX
          },
          success: () => {
            
            // Close the modal using Vue's reactivity
            this.thresholdsTableKey = Date.now();
            this.closeThresholdModal();
            
            this.showSuccess('Thresholds saved successfully');
          },
          error: () => {
            this.showError('Failed to save thresholds');
          }
        });
      },

      get_threshold() {
        const TOKEN = localStorage.getItem('token');
        const GET_SERVICE_THRESHOLD_API = `${API_BASE_URL}/verify_api/form_management_api/get_service_thresholds_api/${this.service_id}`;
        
        $.ajax({
          url: GET_SERVICE_THRESHOLD_API,
          method: 'GET',
          contentType: 'application/json',
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          beforeSend: () => {
            this.loading = true;
          },
          success: (response) => {
            if (response.redirect) {
              this.logout();
              return;
            }
            
            // Update thresholds with data from the backend
            if (response.status === 'success' && response.data) {
              // Update the thresholds with the response data
              this.thresholds = response.data;
              this.thresholdsTableKey = Date.now();
            } else {
              console.error("Error in response format:", response);
              this.showError('Invalid response format from server');
            }
            
            this.loading = false;
          },
          error: (xhr, status, error) => {
            this.loading = false;
            let error_message = 'Error Getting Service Threshold';
            
            // Try to get more specific error message if available
            if (xhr.responseJSON && xhr.responseJSON.message) {
              error_message = xhr.responseJSON.message;
            }
            
            console.error("API Error:", error, xhr.responseText);
            
            this.showError(error_message);
          }
        });
      },

      getTotalWeight() {
        let total = 0;
        this.ordered_questions.forEach(question => {
          if (question.is_active && question.weight) {
            total += parseInt(question.weight);
          }
        });
        return total;
      },

      validateThresholds() {
        this.thresholdError = null;
        
        // Limit input to 100%
        if (this.currentLevel === 'high' || this.currentLevel === 'low') {
          if (this.editThreshold.value > 100) {
            this.editThreshold.value = 100;
          } else if (this.editThreshold.value < 0) {
            this.editThreshold.value = 0;
          }
        } else if (this.currentLevel === 'medium') {
          if (this.editThreshold.lowerValue > 100) {
            this.editThreshold.lowerValue = 100;
          } else if (this.editThreshold.lowerValue < 0) {
            this.editThreshold.lowerValue = 0;
          }
          
          if (this.editThreshold.upperValue > 100) {
            this.editThreshold.upperValue = 100;
          } else if (this.editThreshold.upperValue < 0) {
            this.editThreshold.upperValue = 0;
          }
        }
        
        // Check for threshold value overlap
        if (this.currentLevel === 'high') {
          const highValue = this.editThreshold.value;
          const mediumUpperValue = this.thresholds.medium.upperValue;
          
          if (this.editThreshold.operator === '≥' && mediumUpperValue && this.thresholds.medium.upperOperator === '≤') {
            if (highValue <= mediumUpperValue) {
              this.thresholdError = `High threshold (${highValue}%) must be greater than Medium upper threshold (${mediumUpperValue}%)`;
            }
          } else if (this.editThreshold.operator === '>' && mediumUpperValue && this.thresholds.medium.upperOperator === '<') {
            if (highValue <= mediumUpperValue) {
              this.thresholdError = `High threshold (${highValue}%) must be greater than Medium upper threshold (${mediumUpperValue}%)`;
            }
          }
        } else if (this.currentLevel === 'medium') {
          const mediumLowerValue = this.editThreshold.lowerValue;
          const mediumUpperValue = this.editThreshold.upperValue;
          const lowValue = this.thresholds.low.value;
          const highValue = this.thresholds.high.value;
          
          // Check lower bound against low threshold
          if (mediumLowerValue <= lowValue && this.thresholds.low.operator === '≤') {
            this.thresholdError = `Medium lower threshold (${mediumLowerValue}%) must be greater than Low threshold (${lowValue}%)`;
          }
          
          // Check upper bound against high threshold
          if (mediumUpperValue >= highValue && this.thresholds.high.operator === '≥') {
            this.thresholdError = `Medium upper threshold (${mediumUpperValue}%) must be less than High threshold (${highValue}%)`;
          }
          
          // Check that lower is less than upper
          if (mediumLowerValue >= mediumUpperValue) {
            this.thresholdError = `Medium lower threshold (${mediumLowerValue}%) must be less than upper threshold (${mediumUpperValue}%)`;
          }
        } else if (this.currentLevel === 'low') {
          const lowValue = this.editThreshold.value;
          const mediumLowerValue = this.thresholds.medium.lowerValue;
          
          if (this.editThreshold.operator === '≤' && mediumLowerValue && this.thresholds.medium.lowerOperator === '≥') {
            if (lowValue >= mediumLowerValue) {
              this.thresholdError = `Low threshold (${lowValue}%) must be less than Medium lower threshold (${mediumLowerValue}%)`;
            }
          } else if (this.editThreshold.operator === '<' && mediumLowerValue && this.thresholds.medium.lowerOperator === '>') {
            if (lowValue >= mediumLowerValue) {
              this.thresholdError = `Low threshold (${lowValue}%) must be less than Medium lower threshold (${mediumLowerValue}%)`;
            }
          }
        }
      },

      handleButtonClick(question) {
        // Check if the question has a weight assigned
        if (!question.weight || question.weight == 0) {
          // Show the tooltip or warning
          question.showTooltip = true;
          setTimeout(() => {
            question.showTooltip = false;
          }, 3000); // Hide the tooltip after 3 seconds
          return;
        }
        
        // Set the question ID and open the config modal
        this.question_id = question.id;
        this.openConfigModal(question);
      },
      calculateWeightPercentages() {
        // Calculate total weight of ONLY questions that have weights > 0
        const checkedQuestions = this.ordered_questions.filter(q => 
          q.is_active && (parseInt(q.weight) > 0)
        );
        
        const totalWeight = checkedQuestions.reduce((sum, q) => 
          sum + parseInt(q.weight || 0), 0
        );
        
        // Store the total for use in calculations
        this.totalWeight = totalWeight > 0 ? totalWeight : 1; // Avoid division by zero
      },
      
      getWeightPercentage(questionId) {
        // Get only checked questions with weights > 0
        const checkedQuestions = this.ordered_questions.filter(q => q.is_active && parseInt(q.weight) > 0);
        
        if (checkedQuestions.length === 0) return 0;
        
        // Calculate total weight of all checked questions
        const totalWeight = checkedQuestions.reduce((sum, q) => sum + parseInt(q.weight || 0), 0);
        
        if (totalWeight === 0) return 0;
        
        // Find the specific question
        const question = this.ordered_questions.find(q => q.id === questionId);
        if (!question || !question.weight) return 0;
        
        // Calculate the percentage with proper number handling
        return (parseInt(question.weight) / totalWeight * 100);
      },

      saveScore() {
        const TOKEN = localStorage.getItem('token');
        const SET_SCORE_API = `${API_BASE_URL}/verify_api/form_management_api/set_question_score_api/`;
        
        // Ensure we're using integer values
        const weight = parseInt(this.weightQuestion.weight) || 0;
        
        const FORM_DATA = {
          question_id: this.weightQuestion.id,
          service_id: this.service_id,
          score: weight
        };
        
        $.ajax({
          url: SET_SCORE_API,
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(FORM_DATA),
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          beforeSend: () => {
            // Remove loading modal for better UX
          },
          success: async () => {
            await this.fetch_custom_service_question();

            // Update the question in our local array with the integer weight
            const index = this.ordered_questions.findIndex(q => q.id === this.weightQuestion.id);
            if (index !== -1) {
              this.ordered_questions[index].weight = weight;
            }

            this.calculateWeightPercentages();
            this.closeWeightModal();

            this.showSuccess('Score saved successfully');
          },
          error: () => {
            this.showError('Failed to save score');
          }
        });
      },      

      // Open the weight setting modal
      openWeightModal(questionId) {
        const question = this.ordered_questions.find(q => q.id === questionId);
        if (question) {
          this.weightQuestion = JSON.parse(JSON.stringify(question)); // Clone the question data
          this.showWeightModal = true;
        }
      },
      
      // Close the weight modal
      closeWeightModal() {
        this.showWeightModal = false;
        this.weightQuestion = {};
      },

      openModal(level) {
        this.currentLevel = level;
        
        // Set modal title based on level
        this.modalTitle = `Edit ${level.charAt(0).toUpperCase() + level.slice(1)} Severity Threshold`;
        
        // Create a deep copy of the threshold for editing
        this.editThreshold = JSON.parse(JSON.stringify(this.thresholds[level]));
        this.validationError = null;
        
        // Show the modal using Vue's reactivity
        this.showThresholdModal = true;
    },

    closeThresholdModal() {
      this.showThresholdModal = false;
      this.validationError = null;
  },

  showNumericOperators() {
    return this.selectedQuestion.question_type === 'Number';
  },
  
  showTextOperators() {
    return this.selectedQuestion.question_type === 'Text' || 
           this.selectedQuestion.question_type === 'Textarea';
  },
  
  showSelectOperators() {
    return this.selectedQuestion.question_type === 'Selection' || 
           this.selectedQuestion.question_type === 'Multi Selection' || 
           this.selectedQuestion.question_type === 'Checkbox';
  },
  
  showBooleanOperators() {
    return this.selectedQuestion.question_type === 'Boolean';
  },
  
  showDateOperators() {
    return this.selectedQuestion.question_type === 'Date';
  },
  
  isMaxRulesReached() {
    // For select/choice type questions, limit rules to number of options
    if ((this.selectedQuestion.question_type === 'Selection' || 
         this.selectedQuestion.question_type === 'Choice' || 
         this.selectedQuestion.question_type === 'Checkbox') && 
        this.selectedQuestion.options) {
      return this.selectedQuestion.rules.length >= this.selectedQuestion.options.length;
    }
    
    // For boolean questions, limit to 2 rules (true/false)
    if (this.selectedQuestion.question_type === 'Boolean') {
      return this.selectedQuestion.rules.length >= 2;
    }
    
    // For File type, limit to 2 rules (extension and size)
    if (this.selectedQuestion.question_type === 'File') {
      return this.selectedQuestion.rules.length >= 2;
    }
    
    // Default for other types: allow up to 5 rules
    return this.selectedQuestion.rules.length >= 5;
  },
      validateThreshold() {
        // Convert string values to numbers for comparison
        if (this.currentLevel === 'high') {
          const highValue = parseFloat(this.editThreshold.value);
          const mediumUpperValue = parseFloat(this.thresholds.medium.upperValue);
          
          if (highValue < mediumUpperValue) {
            return `High threshold (${highValue}%) must be greater than or equal to Medium's upper threshold (${mediumUpperValue}%)`;
          }
        } 
        else if (this.currentLevel === 'medium') {
          const upperValue = parseFloat(this.editThreshold.upperValue);
          const lowerValue = parseFloat(this.editThreshold.lowerValue);
          const highValue = parseFloat(this.thresholds.high.value);
          const lowValue = parseFloat(this.thresholds.low.value);
          
          if (upperValue > highValue) {
            return `Medium's upper threshold (${upperValue}%) must be less than or equal to High threshold (${highValue}%)`;
          }
          
          if (lowerValue < lowValue) {
            return `Medium's lower threshold (${lowerValue}%) must be greater than or equal to Low threshold (${lowValue}%)`;
          }
          
          if (upperValue <= lowerValue) {
            return `Medium's upper threshold (${upperValue}%) must be greater than its lower threshold (${lowerValue}%)`;
          }
        }
        else if (this.currentLevel === 'low') {
          const lowValue = parseFloat(this.editThreshold.value);
          const mediumLowerValue = parseFloat(this.thresholds.medium.lowerValue);
          
          if (lowValue > mediumLowerValue) {
            return `Low threshold (${lowValue}%) must be less than or equal to Medium's lower threshold (${mediumLowerValue}%)`;
          }
        }
        
        return null;
      },

      getColorForThreshold(level) {
        if (level === 'high') {
          // Customize high severity color based on threshold value
          const value = this.thresholds.high.value;
          // Higher values get darker red
          return `rgba(${Math.min(255, 200 + (value/100) * 55)}, ${Math.max(0, 70 - (value/100) * 70)}, ${Math.max(0, 70 - (value/100) * 70)}, 1)`;
        } else if (level === 'medium') {
          // Customize medium severity color based on threshold values
          const lowerValue = this.thresholds.medium.lowerValue;
          const upperValue = this.thresholds.medium.upperValue;
          const midPoint = (lowerValue + upperValue) / 2;
          // Adjust yellow/orange based on range
          return `rgba(${Math.min(255, 200 + (midPoint/100) * 55)}, ${Math.min(255, 150 + (midPoint/100) * 105)}, 0, 1)`;
        } else if (level === 'low') {
          // Customize low severity color based on threshold value
          const value = this.thresholds.low.value;
          // Lower values get lighter green
          return `rgba(${Math.max(0, 100 - (value/100) * 100)}, ${Math.min(255, 180 + (value/100) * 75)}, ${Math.max(0, 60 - (value/100) * 60)}, 1)`;
        }
        return '';
      },
    },
    computed: {
      rulesTableKey() {
        return this.ordered_questions.map(q => q.id).join('-');
      },
      thresholdsTableRows() {
        return [
          {
            level: 'High',
            threshold: `${this.thresholds.high.operator} ${this.thresholds.high.value}%`,
            key: 'high'
          },
          {
            level: 'Medium',
            threshold: `${this.thresholds.medium.lowerOperator} ${this.thresholds.medium.lowerValue}% and ${this.thresholds.medium.upperOperator} ${this.thresholds.medium.upperValue}%`,
            key: 'medium'
          },
          {
            level: 'Low',
            threshold: `${this.thresholds.low.operator} ${this.thresholds.low.value}%`,
            key: 'low'
          }
        ];
      },
      check_question_type(){
        return this.question_type === 'Checkbox' || this.question_type === 'Selection';
      },

      service_id(){
        return this.$store.getters.get_service_id
      },

      lowRangeWidth() {
        return this.editThreshold.value || this.thresholds.low.value || 50;
      },
      
      mediumRangeWidth() {
        const lowVal = this.editThreshold.value || this.thresholds.low.value || 50;
        const highStart = this.editThreshold.upperValue || this.thresholds.medium.upperValue || 75;
        return highStart - lowVal;
      },
      
      highRangeWidth() {
        const highStart = this.editThreshold.upperValue || this.thresholds.medium.upperValue || 75;
        return 100 - highStart;
      },

      isMediumLight() {
        if (!this.thresholds?.medium) return false;
        const midPoint = (this.thresholds.medium.lowerValue + this.thresholds.medium.upperValue) / 2;
        return midPoint < 65; // Use dark text if mid-point is below 65%
      },

      is_order_changed() {
        const current_order = this.ordered_questions.map(q => q.id);
        const last_saved = this.last_saved_ordered_ids;
        if (current_order.length !== last_saved.length) return true;
        for (let i = 0; i < current_order.length; i++) {
          if (current_order[i] !== last_saved[i]) return true;
        }
        return false;
      },
    },
    async mounted() {
      if (!validateToken(this.$router)) {
        return;
    }
      try {
        await this.fetch_custom_service_question();
        await this.get_questions();

        this.calculateWeightPercentages();
        this.get_threshold();

      } catch (error) {
        console.error("Error loading questions", error);
      }
    },

    watch: {
      // Add a watcher for activeTab to ensure percentages are calculated when switching to rules tab
      activeTab(newTab) {
        if (newTab === 'rules') {
          this.calculateWeightPercentages();
        }
      },
      assigned_question_ids: {
        handler() {
          this.updateOrderedQuestions();
        },
        deep: true,
        immediate: true
      }
    }
    
  }
